import { render, staticRenderFns } from "./HealthManagementAreaConfigurationModal.vue?vue&type=template&id=7f1b2bf5&"
import script from "./HealthManagementAreaConfigurationModal.vue?vue&type=script&lang=js&"
export * from "./HealthManagementAreaConfigurationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports